import React from 'react';
import propTypes from 'prop-types';
import Text from '../../typography'
import {Grid, Box} from '@mui/material';
import styled from '@emotion/styled';
import {Cta} from '../../ui';
import {theme} from '../../../themes/default-theme';
import qs from 'qs';

const Wrapper = styled.div`  
  h3 {
    font-weight:800;
  }
  ${props => props.backgroundColor === 'black' ? `
      background:${theme.palette.shadeBlack};
      table {
        background:${theme.palette.shadeBlack} !important;
        td {
          background:#292929 !important;
          border-color:#0a0a0a !important;
        }
        th {
          color:${theme.palette.white} !important;
        }
        span.optional {
          background:#0a0a0a !important;
        }
      }
      h3, p, li, ul, ol, div {   
        color:${theme.palette.white} !important;
      }
    `
    : `      
      background:${theme.palette.lightGrey};
    `
  };
`

const Container = styled.div`  
  max-width:1220px;
  margin:auto;
  padding: 60px 55px;
  ${theme.breakpoints.down("sm")} {
    padding: 60px 0;
  }
`

const CustomBox = styled(Box)`
  ${theme.breakpoints.down("sm")} {
    padding: 0;
  }
`

const IndicatorCTAs = styled.div`  
  width:100%;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  align-items:center;
  gap:20px;
  margin-top:30px;
  padding-left:0;

  ${theme.breakpoints.up("md")} {
    margin-top:40px;
    flex-direction:row;
  }
  ul {
    list-style:none;
    margin:0;
    padding:0;
    li {
      display:inline-block;
      font-size:14px;
      line-height:23px;    
      margin-bottom:0;
      margin-right:50px; 
      padding-left: 20px;
      &:before {
        left: 0 !important;
      } 

      ${theme.breakpoints.down('md')}{
        margin-left: 25px;
        margin-right: 15px;
      }
      ${props => props.backgroundColor === 'black' ? `
        color:${theme.palette.white};
      `  
      : `
        color:${theme.palette.charcoal};
      `}; 
      &:first-child {
        &:before {
          width:12px;
          height:12px;
          border-radius:50%;
          background-color:${theme.palette.vividBlue};
          top:6px !important;
          content:"" !important;
        }
      }
      &:nth-child(2) {
        &:before {
          width:13px;
          height:13px;          
          border:2px solid ${theme.palette.vividBlue};
          border-radius:50%;
          top:6px !important;
          content:"" !important;
          ${props => props.backgroundColor === 'black' ? `
            background:#0a0a0a;
          `  
          : `
            background:${theme.palette.white};
          `}; 
        }
      }
      &:last-child {
        &:before {
          content:"" !important;
          width:12px;
          height:3px;
          background:${theme.palette.vividBlue};
        }
      }
    }
  }
  a {
    display:inline-block;
    width:auto;
    margin-left:20px;
    ${theme.breakpoints.down('md')}{
      margin-bottom: 12px;
      margin-left: 10px;
      margin-right: 10px;
    }
    
  }  
`

const TableContainer = styled.div`  
  padding-top:30px;
  table {
    background:${theme.palette.white};
    width:100%;
    td {
      background:#f9f9fb;
      font-size:14px;
      line-height:17px;
      padding:12px 10px; 
      vertical-algin:middle;
      border: 1px solid ${theme.palette.lightGrey};
      text-align:center;
      &:first-child {
        text-align:left;
      }
    }
    th {
      vertical-algin:middle;
      text-align:center;
      padding:5px 10px;
      padding-top:25px;
      opacity:0;

      p {
        color:${theme.palette.charcoal};
        &:first-child {
          font-size:14px;
          line-height:18px; 
          text-transform:uppercase;
          margin:0;
          padding:0 0 2px 0;
        }
        &:last-child {
          font-size:13px;
          margin-top:0;
          padding-top:0;
          margin-bottom:0;
          padding-bottom:0;
          line-height:18px; 
        }
      }
      &:first-child {
        opacity:1;
        width:70%;
        font-size:18px;
        line-height:24px;
        text-transform:uppercase;
        color:${theme.palette.charcoal};
        text-align:left;
      }
    }
    &:first-child {
      th {
        opacity:1;
      }
    }
  }

  span {
    display:inline-block;
    margin:auto;
    &.standard {    
      width:12px;
      height:12px;
      border-radius:50%;
      background-color:${theme.palette.vividBlue};
    } 
    &.optional {
      width:13px;
      height:13px;
      border-radius:50%;
      background:${theme.palette.white};
      border:2px solid ${theme.palette.vividBlue};
    }
    &.na {
      width:12px;
      height:3px;
      background:${theme.palette.vividBlue};
    }
  }
`

const specsTableDefaultPropModels = [];
const specsTableDefaultPropCtas = [];
const specsTableDefaultPropSections = [];

const SpecsTable = ({
  background = null,
  title = null, 
  models = specsTableDefaultPropModels,
  ctas = specsTableDefaultPropCtas,
  sections = specsTableDefaultPropSections,
  uri,
  seriesId,
  rangeId
}) => {
  const specPdfUrl = uri && models ? `${uri}/spec-pdf-form?models=${models.map(item => item.id).join(',')}` : null
  const compareData = models.map(item => {
    return item.id ? {
      range: rangeId,
      series: seriesId,
      model: item.id,
    } : {
      range: rangeId,
      series: seriesId
    }
  })

  const param = qs.stringify({items: compareData});
  const compareUrl = `/compare?${param}`

  // const IOS = /iPhone|iPod/.test(navigator.userAgent)
  console.log('specPdfUrl', models, specPdfUrl, param);

  return (
    <Wrapper backgroundColor={background}>    
      <Container>
          {title &&
            <Box px={2}>
              <Text variant="h3" uppercase="true" align="center" colour="charcoal">{title}</Text>
            </Box>
          }
          <CustomBox px={2}>
            <IndicatorCTAs backgroundColor={background}>
              <div>
                  <ul>
                    <li>Standard</li>
                    <li>Optional</li>
                    <li>Not Available</li>
                  </ul>
              </div>
              <div>
              <Cta primary href={compareUrl} target="_blank">
                Compare Models
              </Cta>
              {(specPdfUrl) &&
                <Cta primary href={specPdfUrl} target="_blank">
                  Download Spec Sheet
                </Cta>
              }
                {/* {ctas &&
                  ctas.map((item, index) => {
                    return(
                      <Cta primary href={item.href || '#'}>
                        {item.title}
                      </Cta>
                    )
                  })} */}
              </div>
            </IndicatorCTAs>
            <TableContainer>
              {sections &&
                sections.map(function(item, index) {
                  return (
                    <table cellspacing='0' cellpadding=''>
                      <tr>
                        <th>
                          {item.title}
                        </th>
                        {models.map(function(model, i) {
                          return (
                            <th>
                              <p>{model.series}</p>
                              <p>{model.model}</p>
                            </th>
                          )
                        })}  
                      </tr>
                      {item.features.map(function(column, index) {
                          return (
                            <tr>
                              <td>{column.title}</td>
                              {column.values.map(function(value, y) {
                                return (
                                  <td>
                                    <span class={value}></span>
                                  </td>
                                )
                              })} 
                            </tr>
                          )
                        })}                      
                    </table>
                  )
              })}
            </TableContainer>
          </CustomBox>
      </Container>
    </Wrapper>
  )
}

SpecsTable.propTypes = {
  background: propTypes.string,
  title: propTypes.string,
  models: propTypes.array,
  ctas: propTypes.array,
  sections: propTypes.array
}

export default SpecsTable